import { createApiClient, type ApiClient } from '@sshop/api-client';

import { env } from '@/shared/config/env';
import { getAuthToken, setAuthToken } from '@/shared/lib/authToken';
import { getCartToken, setCartToken } from '@/shared/lib/cartToken';
import { getWishlistToken, setWishlistToken } from '@/shared/lib/wishlistToken';
import { routeLocale } from '@/shared/lib/routeLocale';
import { activityHeaders } from '@/shared/lib/activityIdentity';

/**
 * Single ApiClient instance for the web app. Features access services through
 * this object — never instantiate another client and never call ky/fetch.
 *
 *   import { api } from '@/shared/lib/apiClient';
 *
 *   const productsQuery = defineQuery({
 *     queryKey: queryKeys.product.list(filters),
 *     queryFn: () => api.products.list(filters),
 *   });
 */
export const api: ApiClient = createApiClient({
  backend: 'laravel',
  // The preview storefront is hosted on a different origin from Laravel, so
  // always honor the build-time API URL instead of assuming a same-origin API.
  baseUrl: env.API_BASE_URL,
  getAuthToken: () => getAuthToken(),
  // Route navigation precedes i18next's effect; requests must use the URL's
  // locale even during the first render after a language switch.
  getLocale: routeLocale,
  getCartToken: () => getCartToken(),
  setCartToken: (token) => setCartToken(token),
  getWishlistToken: () => getWishlistToken(),
  getActivityHeaders: activityHeaders,
  setWishlistToken: (token) => setWishlistToken(token),
  onUnauthorized: () => {
    setAuthToken(null);
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('auth:unauthorized'));
    }
  },
});
